module.exports = new __parcel__URL__("brief-answers-to-the-big-questions.04a4cf8a.jpg").toString();